// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: a document's icon and title, shared by the card and the viewer.

import {type DocumentKind, htmlTitle, markdownTitle} from '@app/features/document_preview/DocumentPreviewUtils';
import {IconFileTypeHtml, IconMarkdown} from '@tabler/icons-react';

/** The title a document shows: its own (<title>, first heading), else the file name. */
export function documentTitle(kind: DocumentKind, text: string, name: string): string {
	return (kind === 'html' ? htmlTitle(text) : markdownTitle(text)) ?? name;
}

export function DocumentKindIcon({kind, size = 18}: {kind: DocumentKind; size?: number}) {
	return kind === 'html' ? <IconFileTypeHtml size={size} stroke={1.7} /> : <IconMarkdown size={size} stroke={1.7} />;
}
